import { panelType } from '@bimser/common';
import {
	BCCard,
	BCList,
	BCLoading,
	BCSkeleton,
	ContentType,
	findMessage,
	OnScrollbarsScroll
} from '@bimser/components';
import { MLHelper, isNullOrUndefined } from '@bimser/core';
import React from 'react';
import Style from '../../assets/style.scss';
import IProcessesProps from '../../entities/widgets/IProcessesProps';
import { tileTypeAndKeys } from '../../utils';
import { IProcess } from '../../entities/widgets/model/types/IProcess';
import IconEba from '@bimser/icons/16/ico-eba';
import classNames from 'classnames/bind';
import { ProjectPlatform } from 'modules/workflow/entities/IWorkflowItem';
const cx = classNames.bind(Style);

const emptyView = require('../../../../assets/report-empty.svg');

const pageSize = 10;

export default (props: IProcessesProps) => {
	const onLoadMore: OnScrollbarsScroll = instance => {
		const { scrollOffsetElement } = instance.elements();
		const { scrollTop, clientHeight, scrollHeight } = scrollOffsetElement;
		const isInBottom = Math.floor(scrollTop) === scrollHeight - clientHeight;

		if (isInBottom && props.hasMore && !props.loading) {
			props.onLoadMore({
				panelId: props.panelId,
				panelType: panelType.startupLayout,
				data: {
					limit: { skip: props.data?.length, take: pageSize }
				}
			});
		}
	};

	const renderCustomEmpty = () => (
		<BCLoading show={props.loading}>
			<div
				data-selenium-id="dashboardProcessEmptyView"
				className={cx({ emptyView: true, inCard: true, hasDefaultPadding: true })}
			>
				<img
					src={emptyView.default}
					className={Style.emptyViewImg}
				/>
				<span className={Style.emptyViewTitle}>{findMessage.get('103295')}</span>
				<span className={Style.emptyViewDesc}>{findMessage.get('103296')}</span>
			</div>
		</BCLoading>
	);

	const geteBAIcon = (projectPlatform: ProjectPlatform) => {
		if (projectPlatform !== ProjectPlatform.eBA) return null;

		return (
			<IconEba
				height="32px"
				width="32px"
				style={{ minWidth: '32px' }}
			/>
		);
	};

	const getItemCaption = (item: IProcess) => {
		if (item.projectPlatform === ProjectPlatform.Synergy) {
			const projectCaption = MLHelper.getMLText(item.projectCaption) || item.projectName;
			const flowCaption = MLHelper.getMLText(item.flowCaption) || item.flowName;

			return `${projectCaption} - ${flowCaption}`;
		} else if (item.projectPlatform === ProjectPlatform.eBA) {
			return MLHelper.getMLText(item.projectCaption);
		}
	};

	const renderItem = (item: IProcess) => {
		const isSelected = props.selectedData?.id == item.id;

		return (
			<>
				<div
					className={cx({
						processCaptionCell: true,
						selected: props.selectedData ? isSelected : false
					})}
					id={item.id}
				>
					<span className={Style.processCaptionCellLabel}>{getItemCaption(item)}</span>
					{geteBAIcon(item.projectPlatform)}
					<span className={Style.processCaptionCellCount}> ({item.count})</span>
				</div>
				{renderProgressCell(item)}
			</>
		);
	};

	const renderProgressCell = (item: IProcess) => {
		if (!isNullOrUndefined(props?.selectedTile) && props?.tileCounts) {
			const isSelected = props.selectedData?.id == item.id;
			const selectedTileKey = Object.keys(tileTypeAndKeys).find(
				key => tileTypeAndKeys[key] == props.selectedTile
			);
			const size = Math.log10(item.count) || 0.1;
			const value = (size * 100) / (Math.log10(props.tileCounts?.[selectedTileKey]) || 0.1);

			return (
				<div
					className={cx({
						processCountCell: true,
						selected: props.selectedData ? isSelected : false
					})}
					id={item.id}
				>
					<div
						className={Style.processCountCellProgress}
						style={{ width: `${value}%` }}
					></div>
				</div>
			);
		}

		return <span></span>;
	};

	const onSelect = (args: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		const newSelected = props.data.find(item => item.id == args.currentTarget.id);
		const isSelectedSame = props.selectedData?.id == newSelected?.id;

		if (newSelected && !isSelectedSame) {
			props.onClickProcess({
				panelId: props.panelId,
				panelType: panelType.startupLayout,
				data: newSelected
			});
		}
	};

	return (
		<BCCard
			bordered={false}
			title={<span className={Style.widgetHeader}>{findMessage.get('102316')}</span>}
			className={cx({ processesContainer: true, isEmpty: !props.data?.length })}
			seleniumId="dashboardProcessesCard"
		>
			<BCSkeleton
				loadingStatus={!props.data?.length && props.loading}
				contentType={ContentType.DashboardProcessesGrid}
			>
				<BCList
					dataSource={props.data}
					renderItem={renderItem}
					customEmpty={renderCustomEmpty()}
					infinityScroll={props.hasMore || props.data.length > 0}
					scrollHeight="100%"
					loadingSkeletonContent={ContentType.DashboardProcessesGridItem}
					loadingSkeletonHeight={40}
					loadingSkeletonShow={props.hasMore}
					loading={props.loading}
					onScrollInfinityScroll={onLoadMore}
					onClickListItem={onSelect}
				/>
			</BCSkeleton>
		</BCCard>
	);
};
